module.exports = __webpack_public_path__ + "media/components/home/masthead-vectors/img/rebrand_800x400-5d94983adb553effdfd4f383269bb0e8.jpg";